import React from 'react';
import blogPosts from '../lib/blogposts.js'; // adjust path as needed
import toolPages from '../lib/toolPages';
import Seo from './Seo';

const Sitemap = () => {
    return (
        <div className="page pt-32">
            <Seo
                title="HTML Sitemap | CompressImages.org"
                description="Find an easy-to-browse list of all pages and articles published on CompressImages.org."
                path="/sitemap"
            />

            <div className="article-wrap">
                <div className="section-hd">
                    <h1>HTML Sitemap</h1>
                    <p>Find every page and guide published on CompressImages.org.</p>
                </div>

                {/* Main site pages */}
                <section className="mb-10">
                    <h2>Core Pages</h2>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/tool">Image Compression Tool</a></li>
                        <li><a href="/tools">All Image Tools</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-of-service">Terms Of Service</a></li>
                    </ul>
                </section>

                <section className="mb-10">
                    <h2>Image Tools</h2>
                    <ul>
                        {toolPages.map(({ path, title }) => (
                            <li key={path}>
                                <a href={path}>{title}</a>
                            </li>
                        ))}
                    </ul>
                </section>

                {/* Blog / resources */}
                <section className="mb-10">
                    <h2>Blog &amp; Resources</h2>
                    <ul>
                        {blogPosts.map(({ slug, title, date }) => (
                            <li key={slug}>
                                <a href={`/blog/${slug}`}>
                                    {title} {date && <span>({date})</span>}
                                </a>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default Sitemap;
